import { FC } from 'react'
import styles from './ExtraordinaryPeopleStatic.module.scss'
import { ExtraordinaryPeopleStaticProps, QuoteProps } from './types'
import { getDefaultQuotes } from './utils'
import { YellowStar } from 'components/Phantom/Icon/icons/custom/YellowStar'
import { Type } from 'components/Type'

export const ExtraordinaryPeopleStatic: FC<ExtraordinaryPeopleStaticProps> = (props) => {
	const { quotes = getDefaultQuotes() } = props
	return (
		<section className={styles.container}>
			<article className={styles.inner_container}>
				<header className={styles.header}>
					<Type.Eyebrow>Our community</Type.Eyebrow>
					<Type.Headline1 as={'h2'}>Fueling extraordinary people like you</Type.Headline1>
				</header>

				<ul className={styles.quotes}>
					{quotes.map((quote, i) => (
						<li key={quote.tag}>
							<Quote {...quote} />
						</li>
					))}
				</ul>
			</article>
		</section>
	)
}

const Quote: FC<QuoteProps> = (props) => {
	return (
		<div className={styles.quote}>
			<Type.Eyebrow
				as={'h3'}
				className={styles.tag}
			>
				{props.tag}
			</Type.Eyebrow>

			<Stars />
			<Type.Headline3
				as={'p'}
				className={styles.author}
			>
				{props.author}
			</Type.Headline3>
			<Type.Body1 className={styles.content}>{props.content}</Type.Body1>
		</div>
	)
}

const Stars = () => (
	<div className={styles.stars}>
		<YellowStar />
		<YellowStar />
		<YellowStar />
		<YellowStar />
		<YellowStar />
	</div>
)
